<div class="app-bg scroll-fix">

    <div class="container container-padding">
        <h1 class="page-header" *ngIf="policies.length === 1">
            {{ 'POLICY.HEADER' | translate: {number: policies[0].number} }}
        </h1>
        <h1 class="page-header" *ngIf="policies.length > 1">
            {{ 'POLICY.HEADER_MULTIPLE' | translate: {numbers: policyNumber} }}
        </h1>

        <div class="separator"></div>

        <div class="box box-white has-shadow">
            <div class="box-content">
                <div class="box-body">
                    <div class="box-row">
                        <div class="box-item">
                            <div class="row">
                                <div class="col-auto">
                                    <app-output [label]="'POLICY_DATE_AND_CITY' | translate">
                                        {{ policies[0].issueDate | lsnDate }}, {{ policies[0].additionalData.location }}
                                    </app-output>
                                </div>
                                <div class="col" *ngIf="policies[0].type === configurationTypes.FRONTIER">
                                    <app-output [label]="'LABEL.SELLER' | translate">
                                        {{ policies[0].seller.fullName }}
                                    </app-output>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="separator"></div>

        <app-clients-summary-box [document]="policies[0]"
                                 [readonly]="true">
        </app-clients-summary-box>


        <ng-container *ngFor="let policy of policies">
            <div class="separator"></div>

            <app-property-summary-box [document]="policy"
                                      [policyNumber]="policy.number"
                                      [type]="summaryType.POLICY"
                                      [readonly]="true">
            </app-property-summary-box>

            <app-motor-summary-box [document]="policy"
                                   [policyNumber]="policy.number"
                                   [type]="summaryType.POLICY"
                                   [readonly]="true">
            </app-motor-summary-box>

            <app-motor-summary-box [document]="policy"
                                   [policyNumber]="policy.number"
                                   [type]="summaryType.POLICY"
                                   [configurationType]="configurationTypes.FRONTIER"
                                   [readonly]="true">
            </app-motor-summary-box>

        </ng-container>

    </div>
</div>
